import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=210713ec&scoped=true"
import script from "./Highlights.vue?vue&type=script&lang=js"
export * from "./Highlights.vue?vue&type=script&lang=js"
import style0 from "./Highlights.vue?vue&type=style&index=0&id=210713ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210713ec",
  null
  
)

export default component.exports